export const knownPortals = ["zrh", "gva", "bsl"] as const;